import SwiperSlider from '../base';

const selectors = {
  sliderEl: '[data-comp-three-column-slider]',
  nextEl: '[data-navigation-next-el]',
  prevEl: '[data-navigation-prev-el]',
  paginationEl: '[data-pagination-el]',
};

const swiperOptions = {
  slidesPerView: 1,
  spaceBetween: 24,
  preventClicks: false,
  preventClicksPropagation: false,
  navigation: {
    nextEl: selectors.nextEl,
    prevEl: selectors.prevEl,
  },
  pagination: {
    el: selectors.paginationEl,
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
  },
};

export default class SectionThreeColumnSlider extends SwiperSlider {
  static selector = selectors.sliderEl;
  constructor(containerEl) {
    super(containerEl);
    this.generalSlider = new this.Swiper(
      this.$container,
      swiperOptions,
    );
    this.addSlideChangeListener();
    triggerWindowResize();
  }

  addSlideChangeListener() {
    this.generalSlider.on('slideChange', () => {
      window.dispatchEvent(new Event('resize'));
    });
  }
}

function triggerWindowResize() {
  window.setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
}
